import { useEffect, useState } from "react";
import ApiService from "../../../../components/apiService/ApiService";
import CustomSnackbar from "../../../../components/ui/CustomSnackbar/customSnackbar";
import CustomTable from "../../../../components/ui/CustomTable/customTable";
import { CircularProgress } from "@mui/material";
import styles from "./VirtualNumbers.module.css";
import RemoveVnModal from "./Modals/RemoveVnModal";

const VirtualNumbers = ({ accountId }) => {
  //States
  const [response, setResponse] = useState({});
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [showModal, setShowModal] = useState({
    remove: false,
  });
  const [currentRow, setCurrentRow] = useState();

  const [showLoader, setShowLoader] = useState(false);
  const [rows, setRows] = useState([]);
  const [writePermission, setWritePermission] = useState();

  //Handlers
  const handleFeedback = (response) => {
    if (response) {
      setResponse(response.data);
    } else {
      setResponse({
        message: "Unexpected Error. Please Try Again",
        success: false,
      });
    }
    setShowSnackbar(true);
  };

  const fetchData = () => {
    setShowLoader(true);
    ApiService.get(`/api/v1/dashboard/retrieve-vn-addons/${accountId}`)
      .then((res) => {
        setRows(res?.data?.data?.addons);
        setWritePermission(res?.data?.data?.["virtual_number.can_write"]);
        handleFeedback(res);
      })
      .catch((error) => handleFeedback(error?.response))
      .finally(() => setShowLoader(false));
  };

  //Effects
  useEffect(() => {
    fetchData();
  }, [accountId]);

  //Table columns
  const columns = [
    { field: "id", headerName: "ID", maxWidth: 60, flex: 1 },
    { field: "name", headerName: "Name", minWidth: 150, flex: 1 },
    {
      field: "country_code",
      headerName: "Country code",
      maxWidth: 120,
      flex: 1,
    },
    {
      field: "number",
      headerName: "Number",
      minWidth: 180,
      flex: 1,
    },
    { field: "location", headerName: "Location", minWidth: 150, flex: 1 },
    { field: "status", headerName: "Status", maxWidth: 150, flex: 1 },
    { field: "number_type", headerName: "Number type", maxWidth: 100, flex: 1 },
    {
      field: "is_included_in_plan",
      headerName: "Included with plan",
      maxWidth: 150,
      flex: 1,
    },
    {
      field: "options",
      headerName: "",
      minWidth: 50,
      flex: 1,
      renderCell: (params) => (
        <button
          onClick={() => {
            setCurrentRow(params?.row);
            setShowModal((prev) => {
              return { ...prev, remove: true };
            });
          }}
          className={styles.dangerButton}
          disabled={!writePermission}
        >
          Remove
        </button>
      ),
    },
  ];

  return (
    <div>
      {showLoader ? (
        <div className={styles.loader_wrapper}>
          <CircularProgress color="success" size={60} />
        </div>
      ) : (
        <CustomTable
          rows={rows}
          columns={columns}
          disableCheckboxSelection={true}
          noRowsOverlayText="Virtual numbers"
          pageSize={15}
          exportOption={true}
          showFilters={true}
        />
      )}
      {showModal?.remove && (
        <RemoveVnModal
          visible={showModal?.remove}
          onClose={() =>
            setShowModal((prev) => {
              return { ...prev, remove: false };
            })
          }
          id={currentRow?.id}
          accountId={accountId}
          handleFeedback={handleFeedback}
        />
      )}
      {showSnackbar && (
        <CustomSnackbar
          setShowSnackbar={setShowSnackbar}
          message={response?.message}
          type={response?.success ? "success" : "error"}
          onClose={() => setShowSnackbar(false)}
        />
      )}
    </div>
  );
};

export default VirtualNumbers;
